<template>
  <div class="selected-products-container">
    <v-row class="pb-3">
      <v-col cols="12">
        <span class="pl-3 body-1">Produtos selecionados </span>
        <span class="body-1"> ({{ products.length }})</span>
      </v-col>
    </v-row>
    <v-row class="mt-n8">
      <v-col cols="12">
        <div v-if="products.length" class="modal-div">
          <span v-if="!disabled && !isCampaignActivated" class="px-3 label-remove-all" @click="clearAll">Remover todos</span>
          <div v-for="(item, chosenIndex) in formattedChosenItems.slice().reverse()" :key="chosenIndex" class="px-3 mt-3">
            <v-chip
              v-if="!item.isGroup"
              class="body-2"
              close-icon="close"
              close
              :disabled="item.disabled || disabled"
              @click:close="$emit('remove-item', item)"
            >
              <v-tooltip right>
                <template #activator="{ on }">
                  <span v-on="on">
                    {{ item.sku }} -
                    {{ putEllipsis(item.name, 20) }}
                  </span>
                </template>
                <span>{{ item.name }}</span>
              </v-tooltip>
            </v-chip>
            <v-card v-else class="my-2 elevation-0" color="cinza-l80">
              <v-toolbar height="30" color="cinza-l80" flat>
                <v-tooltip right>
                  <template #activator="{ on }">
                    <span class="texto-corrido" v-on="on">
                      {{ putEllipsis(item.name, 30) }}
                    </span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
                <v-spacer />
                <mf-button color="cinza-0" type="icon" icon="close" size="sm" :disabled="item.disabled || disabled" @click="$emit('remove-group', item)" />
              </v-toolbar>
              <v-card-text>
                <v-chip
                  v-for="(product, chosenProductIndex) in item.products"
                  :key="chosenProductIndex"
                  class="mb-2"
                  close
                  close-icon="close"
                  :disabled="item.disabled || disabled"
                  @click:close="$emit('remove-item', product)"
                >
                  <v-tooltip right>
                    <template #activator="{ on }">
                      <span v-on="on">
                        {{ product.sku }} -
                        {{ putEllipsis(product.name, 18) }}
                      </span>
                    </template>
                    <span>{{ product.name }}</span>
                  </v-tooltip>
                </v-chip>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <div v-else>
          <v-alert class="ma-3" type="info" outlined> Selecione um produto </v-alert>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { putEllipsis } from '@/config/helpers.js'
import { mariaCampaign } from '../../../mixins/maria-campaign'

export default {
  name: 'SelectedProducts',

  mixins: [mariaCampaign],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearAll: {
      type: Function,
      required: true,
    },
    initiallyProducts: {
      type: Array,
      required: true,
    },
  },
  emits: ['remove-item', 'remove-group'],
  computed: {
    products() {
      return this.importedItems.concat(this.searchedItems)
    },

    importedItems() {
      return this.importedProducts
    },

    searchedItems() {
      return this.searchedProducts
    },

    formattedChosenItems() {
      return this.products.reduce((accumulator, current) => {
        if (current.isGroup) {
          return this.handleGroupItem(accumulator, current)
        }

        return [
          ...accumulator,
          {
            ...current,
            disabled: this.isInitiallyProducts(current),
          },
        ]
      }, [])
    },
  },
  methods: {
    putEllipsis,

    handleGroupItem(accumulator, current) {
      const productIndex = accumulator.findIndex((item) => item._id && item._id === current.groupInfo._id)

      if (productIndex >= 0) {
        accumulator[productIndex].products.push(current)
        return accumulator
      }

      const group = {
        name: current.group_name || current.nameGroup,
        isGroup: current.isGroup,
        disabled: this.isInitiallyProducts(current),
        _id: current.groupInfo._id,
        __typename: current.groupInfo._id,
        products: [current],
      }

      return [...accumulator, group]
    },

    isInitiallyProducts(product) {
      if (!this.isCampaignActivated) {
        return false
      }
      return this.initiallyProducts.some((initialProduct) => initialProduct.ean === product.ean)
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-products-container {
  .modal-div {
    .label-remove-all {
      font-size: 16px !important;
      color: var(--marca-0-l40);
      text-decoration: underline;
      cursor: pointer;
    }
  }

  ::v-deep .v-chip {
    width: 100%;
    margin: auto;
    justify-content: center;
    border-radius: 5px;
    height: 48px;
    background-color: var(--cinza-l90) !important;

    .v-chip__content {
      width: 100%;
      justify-content: space-between;
    }
  }
}
</style>
